import { observer } from 'mobx-react-lite';
import { CommentStoreProvider } from '../../components/Comment';
import { useParamsIdSuffixUuid } from '../../utils/hook/utils';
import DocumentPage from './DocumentPage';
import type { IDocumentPageProps } from './types';

function DocumentPageWithCommentStore({ id: propsId }: IDocumentPageProps) {
	const paramsId = useParamsIdSuffixUuid();
	const id = propsId || paramsId;

	return (
		<CommentStoreProvider>
			<DocumentPage id={id} />
		</CommentStoreProvider>
	);
}

const DocumentPageWithCommentStoreComponent = observer(
	DocumentPageWithCommentStore
);
export default DocumentPageWithCommentStoreComponent;
